<div class="grid grid-gutter-12">
  <div *ngFor="let part of parts" class="grid-item grid-12">
    <div
      class="grid grid-nowrap grid-center grid-gutter-12"
      *ngIf="part.hxid && part.title"
    >
      <div class="grid-item">
        <span class="tag">{{ part.hxid }}</span>
      </div>
      <div class="grid-item">
        <a
          [routerLink]="getLink(part.hxid)"
          [state]="{ ymGoalName: YmGoalCatalogItem.OpenFromCatalogItem }"
          class="typography grey-800"
        >
          {{ part.title | formatTitle }}
        </a>
      </div>
    </div>
  </div>
</div>
